import { useQuery } from '@shared/modules/use-query/hooks'
import { useCallback, useMemo } from 'react'
import { Insurance } from '../types'
import { InsurancesService } from '../services'

export const useInsuranceList = (enabled: boolean = true) => {
  return useQuery<Insurance[]>(
    useCallback(async () => {
      const result = await InsurancesService.getAll({ page: 1, per_page: 5000 })
      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, []),
    useMemo(() => ({ initialData: [], enabled }), [enabled]),
  )
}
